const tese = [
  
 
  {
        imgs:[
          "/img/tese/jogo.mov",
          "/img/tese/vid1.mov",
          "../img/tese/vid2.mov",
          "/img/tese/oclusao.png",
        ],
        descs:[
            "video do jogo de geometria",
            "Video: Aplicação de demonstração onde é possivel desenhar com o dedo indicador no mundo de realidade aumentada. A precisão é boa mas ainda assim tem algumas falhas.",
            "video: Aplicação interagindo com elementos virtuais, neste caso notas musicais. Este video tem som.",
            "Imagem que demonstra falhas na oclusão. Quando a mão está muito perto da camara a oclusão de objetos torna-se mais fraca e induz o utilizador a erros de percepção de profundidade e espaço."
        ]
  
      }
  ]
  
  export default tese;